export default {
	"8a550bb53d155480f8155c5dc2fbf0c5": "您當前有在學的課程，無法享受推薦禮品哦",
	"cbda7bea79ea94fb9c26283a04a2a29b": "繼續購買"
}
